<template>
  <router-link
    :to="{ name: 'post-view', params: { id: item._id } }"
    class="post-list-item d-flex align-items-center text-body text-decoration-none px-2 py-1 border-bottom"
    @click.native="handleClick"
  >
    <img
      v-if="item.visitor.profile_picture_url && !imageLoadError"
      :src="item.visitor.profile_picture_url"
      class="avatar-circle mr-1 flex-shrink-0"
      :class="isContactBlocked ? 'bg-danger text-white' : ''"
      style="object-fit: cover;"
      alt="Profile Picture"
      @error="imageLoadError = true"
    >
    <div
      v-else
      class="avatar-circle mr-1 flex-shrink-0"
      :class="isContactBlocked ? 'bg-danger text-white' : ''"
    >
      {{ item.visitor.firstname.charAt(0) }}
    </div>

    <div class="flex-grow-1 d-flex flex-column" style="min-width: 0;">
      <div class="d-flex justify-content-between align-items-center w-100 mb-25">
        <div class="d-flex align-items-center mr-1" style="min-width: 0;">
          <span class="font-weight-bolder text-truncate">
            {{ item.visitor.firstname }} {{ item.visitor.lastname }}
          </span>

          <feather-icon
            v-if="isContactBlocked"
            icon="SlashIcon"
            size="14"
            class="text-danger ml-50 flex-shrink-0"
          />
        </div>

        <div class="small flex-shrink-0 text-body">
          {{ (item.reviewed_on || item.created_at) | formatDateTime() }}
        </div>
      </div>

      <div class="d-flex align-items-center w-100" style="min-width: 0;">
        <b-badge
          :variant="statusDetails.variant"
          pill
          class="d-inline-flex align-items-center mr-1 flex-shrink-0 font-weight-bold"
        >
          <span v-if="statusDetails.isReplyRead" class="d-inline-flex align-items-center mr-25">
            <feather-icon icon="CheckIcon" size="14" />
            <feather-icon icon="CheckIcon" size="14" style="margin-left: -7px;" />
          </span>
          <i v-else :class="statusDetails.icon" class="mr-25" style="font-size: 0.85rem;" />

          {{ statusDetails.label }}
        </b-badge>

        <div class="small text-truncate flex-grow-1 text-body">
          {{ messagePreview }}
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'PostListItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    replies: {
      type: Array,
      default: () => [],
    },
    isContactBlocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageLoadError: false,
    };
  },
  computed: {
    messagePreview() {
      if (this.replies && this.replies.length > 0) {
        return this.replies[0].message || this.item.message;
      }
      return this.item.message;
    },
    statusDetails() {
      const details = {
        label: this.$t('postSearch.status.read') || 'Read',
        icon: 'far fa-envelope-open',
        variant: 'light-secondary',
        isReplyRead: false,
      };

      if (!this.item.read_on) {
        details.label = this.$t('postSearch.status.unread') || 'Unread';
        details.icon = 'far fa-envelope';
        details.variant = 'light-primary';
      }

      if (this.replies && this.replies.length > 0) {
        const reply = this.replies[0];
        details.label = this.$t('postSearch.status.replyPending') || 'Reply Pending';
        details.icon = 'far fa-clock';
        details.variant = 'light-secondary';

        if (reply.status && reply.status.toLowerCase() === 'approved') {
          details.label = this.$t('postSearch.status.replied') || 'Replied';
          details.icon = 'fas fa-check';
          details.variant = 'light-secondary';

          if (reply.read_on) {
            details.label = this.$t('postSearch.status.replyRead') || 'Reply Read';
            details.variant = 'light-info';
            details.isReplyRead = true;
          }
        } else if (reply.status && reply.status.toLowerCase() === 'rejected') {
          details.label = this.$t('postSearch.status.replyRejected') || 'Reply Rejected';
          details.icon = 'fas fa-ban';
          details.variant = 'light-danger';
        }
      }
      return details;
    },
  },
  methods: {
    handleClick() {
      if (window.innerWidth < 1200) {
        this.$root.$emit('toggle-mobile-menu', false);
      }
    },
  },
};
</script>
